import { render, staticRenderFns } from "./certificationLayout.vue?vue&type=template&id=70b74698&"
import script from "./certificationLayout.vue?vue&type=script&lang=js&"
export * from "./certificationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports